// Voice Separator's "Speakers − N +" row above the sliders (designer 09-25,
// StemRowLayout.hpp kSpeakerCountW). The demo audio has exactly two speakers,
// so the count is fixed and both buttons are disabled; the row is kept so the
// panel reads like the app's.
import { html } from 'lit';
import type { TemplateResult } from 'lit';

export function renderSpeakersRow(count: number): TemplateResult {
  return html`
    <div class="speakers-row">
      <span class="speakers-label">Speakers</span>
      <span class="value-box speakers-count" aria-label="Speakers" role="status">${count}</span>
      <button class="sm-btn" type="button" aria-label="Fewer speakers" disabled title="Fixed in this demo">-</button>
      <button class="sm-btn" type="button" aria-label="More speakers" disabled title="Fixed in this demo">+</button>
    </div>
  `;
}
